/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max_length: NonNullable<unknown>, needed: NonNullable<unknown> }} Error_Zns_Param_Too_ShortInputs */

const vi_error_zns_param_too_short = /** @type {(inputs: Error_Zns_Param_Too_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tham số chỉ nhận tối đa ${i?.max_length} ký tự, giá trị cần ${i?.needed} ký tự. Chọn mẫu khác hoặc sửa độ dài trên Zalo.`)
};

/**

* @param {Error_Zns_Param_Too_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_param_too_short = /** @type {((inputs: Error_Zns_Param_Too_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Param_Too_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_param_too_short(inputs)
});